/* eslint-disable */
import React, { Component } from 'react';
import Input from 'react-toolbox/lib/input';
import DatePicker from 'react-toolbox/lib/date_picker';
import Dropdown from 'react-toolbox/lib/dropdown';
import Dialog from 'react-toolbox/lib/dialog';
import { connect } from 'react-redux';
import * as actions from 'state/modules/popup';
import _ from 'lodash';
import moment from 'moment';
import styles from './PopupAppointment.css';

let eventData = '';
const minDatetime = new Date();
minDatetime.setDate(minDatetime.getDate() - 1);
const debug = _debug('app:PopupAppointment');
class PopupAppointment extends Component {
  static propTypes = {
    closeAction: React.PropTypes.func,
    saveEventAction: React.PropTypes.func,
    name: React.PropTypes.string,
    address: React.PropTypes.string,
    currentLanguage: React.PropTypes.string,
    contactData: React.PropTypes.objectOf(React.PropTypes.shape({})),
    wholeData: React.PropTypes.objectOf(React.PropTypes.shape({})),
    fetchContactData: React.PropTypes.func,
    strings: React.PropTypes.objectOf(React.PropTypes.shape({})),
    updateToMiscData: React.PropTypes.func
  }
  constructor(props) {
    super(props);
    this.state = {
      startDate: '',
      endDate: '',
      reminder: '',
      startTime: '',
      endTime: '',
      startHour: '',
      startMinute: '',
      startMerdian: '',
      endHour: '',
      endMinute: '',
      endMerdian: '',
      active: false,
      errorMessage: '',
      testValue: '',
      testValueLoc: ''
    };
  }

  componentWillMount() {
    const promised = this.props.fetchContactData(this.props.wholeData.id);
    promised.then((response) => {
      this.setState({ testValue: response.lastname, testValueLoc: response.address1_line1 });
    }, errorResponse => debug(errorResponse));
  }

  inputChangeFun = (textValue) => {
    this.setState({ testValue: textValue });
  }

  inputChangeLocationFun = (textLocvalue) => {
    this.setState({ testValueLoc: textLocvalue });
  }

  startDateAction = (value) => {
    this.setState({ startDate: value });
    this.setState({ endDate: value }); // End Date should be same as start date on selection
  };
  startTimeAction = (value) => {
    this.setState({ startTime: value });
    this.setState({ endTime: (value) }); // End time is start time plus one hour
  };
  startHourAction = (value) => {
    this.setState({ startHour: value });
    if (this.state.endMerdian !== null) {
      this.setState({ endMerdian: this.state.startMerdian });
    }
    if (value === 11) {
      const dayOver = 0;
      return this.setState({ endHour: dayOver });
    }
    return this.setState({ endHour: value + 1 });
  };
  startMinuteAction = (value) => {
    this.setState({ startMinute: value });
    this.setState({ endMinute: (value) }); // End time is start time plus one hour
  };
  startMerdianAction = (value) => {
    let endValue = value;
    this.setState({ startMerdian: value });
    if (this.state.startHour === 10) {
      endValue = (value === 1) ? 0 : 1;
    }
    this.setState({ endMerdian: (endValue) }); // End time is start time plus one hour
  };
  endDateAction = (value) => {
    this.setState({ endDate: value });
  };
  endTimeAction = (value) => {
    this.setState({ endTime: value });
  };
  endHourAction = (value) => {
    this.setState({ endHour: value });
  };
  endMinuteAction = (value) => {
    this.setState({ endMinute: value });
  };
  endMerdianMerdianAction = (value) => {
    this.setState({ endMerdian: value });
  };
  reminderAction = (value) => {
    this.setState({ reminder: value });
  };
  handleToggle = () => {
    this.setState({ active: !this.state.active });
  }
  fetchStartTimeStops = () => {
    const timeStops = [];
    // const currentTime = moment();
    // const startTime = moment(currentTime).add('m', 15 - ((moment().minute()) % 15));// Start Time
    // const endTime = moment(currentTime).add(24, 'hours');// End Time
    let i = 0;
    for (i = 1; i < 13; i += 1) {
      timeStops.push({ value: i, label: i }); // Create JSON object for time dropdown
    }
    // while (startTime <= endTime) {
    // timeStops.push({ value: i, label: moment(startTime).
    // format('hh:mm A') }); // Create JSON object for time dropdown
    // startTime.add('m', 15);
    // i += 1;
    // }
    return timeStops;
  }

  fetchHour = () => {
    const hourArray = [];
    let i = 0;
    for (i = 0; i < 12; i += 1) {
      hourArray.push({ value: i, label: i + 1 }); // Create JSON object for time dropdown
    }
    return hourArray;
  }

  fetchMinutes = () => {
    const minArr = [];
    for (let j = 0; j < 4; j += 1) {
      // arr.push(i + ":" + (j===0 ? "00" : 15*j) );
      minArr.push({ value: j, label: (j === 0 ? '00' : 15 * j) }); // Create JSON object for time dropdown
    }
    return minArr;
  }

  fetchMeridiemType = () => {
    const tempArr = ['AM', 'PM'];
    const MeridiemArr = [];
    for (let j = 0; j <= 1; j += 1) {
      // arr.push(i + ":" + (j===0 ? "00" : 15*j) );
      MeridiemArr.push({ value: j, label: tempArr[j] }); // Create JSON object for time dropdown
    }
    return MeridiemArr;
  }
  action = [
    { label: 'OK', onClick: this.handleToggle }
  ];

  saveEventData = () => {
    let tempStartTime = '';
    let tempEndTime = '';
    if (this.state.startHour !== '' && this.state.startMinute !== '' &&
      this.state.startMerdian !== '') {
      tempStartTime =
        `${this.fetchHour()[this.state.startHour].label}:${this.fetchMinutes()[this.state.startMinute].label} ${this.fetchMeridiemType()[this.state.startMerdian].label}`;
    }
    if (this.state.endHour !== '' && this.state.endMinute !== '' &&
      this.state.endMerdian !== '') {
      tempEndTime =
        `${this.fetchHour()[this.state.endHour].label}:${this.fetchMinutes()[this.state.endMinute].label} ${this.fetchMeridiemType()[this.state.endMerdian].label}`;
    }
    // this.setState({ startTime: });
    const strtDate = this.state.startDate;
    const strings = this.props.strings;
    const sDate = moment(strtDate).format('DD-MM-YYYY');// start date in required format
    const enDate = this.state.endDate;
    const eDate = moment(enDate).format('DD-MM-YYYY');// end date in required format
    const strtTime = (!_.isEmpty(tempStartTime)) ? tempStartTime : '';
    const enTime = (!_.isEmpty(tempEndTime)) ? tempEndTime : '';
    const startDatetime = moment(`${sDate} ${strtTime}`, 'DD-MM-YYYY HH:mm A');
    const endDatetime = moment(`${eDate} ${enTime}`, 'DD-MM-YYYY HH:mm A'); // get datetime object
    const contactData = this.props.contactData;
    contactData.cica_leaddispositionstatus = '3';
    const title = this.props.name;
    const location = this.props.address;
    const reminder = (!isNaN(parseInt(this.state.reminder, 10))) ? this.state.reminder : 0;
    const contactId = this.props.contactData.id;
    const apmtTime = moment(startDatetime).format('YYYY-MM-DD hh:mma');
    const apmtTimeToSync = moment(startDatetime).format('YYYY-MM-DD HH:mm');
    contactData.appointmentdate = apmtTimeToSync;
    const dataToUpdateMisc = {
      leadId: contactId,
      appointmentTime: apmtTime
    };

    if (strtDate !== '' && enDate !== '' && strtTime !== '' && enTime !== '' && title !== '' && location !== '' && reminder !== 0) {
      if (moment(endDatetime).isAfter(startDatetime)) {
        eventData = {
          title: this.props.name,
          location: this.props.address,
          startDate: strtDate.toString(),
          startTime: strtTime,
          endDate: enDate.toString(),
          endTime: enTime,
          reminder: (!Number.isNaN(parseInt(this.state.reminder, 10))) ? this.state.reminder : 0
        };
        this.props.saveEventAction(eventData, contactData);
        this.props.updateToMiscData(dataToUpdateMisc);
      } else {
        this.setState({ active: true, errorMessage: 'End time should be more than start time' });
      }
    } else {
      this.setState({ active: true, errorMessage: strings.errorMessage });
    }
  };

  remainderOptions = [
    { value: '300', label: '5 minutes before' },
    { value: '900', label: '15 minutes before' },
    { value: '1800', label: '30 minutes before' },
    { value: '3600', label: '1 hour before' },
    { value: '7200', label: '2 hours before' },
    { value: '86400', label: '1 day before' },
    { value: '172800', label: '2 days before' }
  ];
  remainderOptionsEs = [
    { value: '300', label: '5 minutos antes' },
    { value: '900', label: '15 minutos antes' },
    { value: '1800', label: '30 minutos antes' },
    { value: '3600', label: '1 hora antes' },
    { value: '7200', label: '2 horas antes' },
    { value: '86400', label: '1 día antes' },
    { value: '172800', label: '2 días antes' }
  ];

  render() {
    const { strings } = this.props;
    return (
      <div className={styles.popupBody}>
        <div className={styles.mainFieldContainer}>
          <div className={styles.fieldContainers}>
            <div className={styles.inputTextDivBig} >
              <span className={styles.labelText}>
                {strings.title}
              </span>
              <span className={styles.labelStarAppointment}>
                *
              </span>
              <Input
                type="text"
                name={'Title'}
                display="flex"
                theme={styles}
                floating={false}
                value={this.state.testValue}
                onChange={this.inputChangeFun}
              />
            </div>
          </div>
          <div className={styles.fieldContainers}>
            <div className={styles.inputTextDivBig} >
              <span className={styles.labelText}>
                {strings.location}
              </span>
              <span className={styles.labelStarAppointment}>
                *
              </span>
              <Input
                type="text"
                name={'Title'}
                display="flex"
                theme={styles}
                floating={false}
                value={this.state.testValueLoc}
                onChange={this.inputChangeLocationFun}
              />
            </div>
          </div>
          <div className={styles.fieldContainers}>
            <div className={styles.inputContainerHolder}>
              <div className={styles.inputTextDiv} >
                <span className={styles.labelText}>
                  {strings.startDate}
                </span>
                <span className={styles.labelStarAppointment}>
                  *
                </span>
                <div className={styles.datePickerPage}>
                  <DatePicker
                    label={strings.startDate}
                    inputFormat={value => `${value.getMonth() + 1}/${value.getDate()}/${value.getFullYear()}`}
                    onChange={this.startDateAction}
                    value={this.state.startDate}
                    minDate={minDatetime}
                    sundayFirstDayOfWeek
                    theme={styles}
                    className={styles.datePicker}
                  />
                </div>
              </div>
              <div className={styles.inputTextDiv} >
                <span className={styles.labelText}>
                  {strings.startTime}
                </span>
                <span className={styles.labelStarAppointment}>
                  *
                </span>
                <div className={styles.inputTextDiv} >
                  <div className={styles.pageDropDown}>
                    <span className={styles.labelSubText}>
                      {strings.hour}
                    </span>
                    <Dropdown
                      auto={false}
                      source={this.fetchHour()}
                      onChange={this.startHourAction}
                      value={this.state.startHour}
                      theme={styles}
                      className={styles.timeDropDown}
                    />
                  </div>
                  <div className={styles.pageDropDown}>
                    <span className={styles.labelSubText}>
                      {strings.minute}
                    </span>
                    <Dropdown
                      auto={false}
                      source={this.fetchMinutes()}
                      onChange={this.startMinuteAction}
                      value={this.state.startMinute}
                      theme={styles}
                      className={styles.timeDropDown}
                    />
                  </div>
                  <div className={styles.pageDropDown}>
                    <span className={styles.labelSubText}>
                      {strings.meridian}
                    </span>
                    <Dropdown
                      auto={false}
                      source={this.fetchMeridiemType()}
                      onChange={this.startMerdianAction}
                      value={this.state.startMerdian}
                      theme={styles}
                      className={styles.timeDropDownMeridian}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.fieldContainers}>
            <div className={styles.inputContainerHolder}>
              <div className={styles.inputTextDiv} >
                <span className={styles.labelText}>
                  {strings.endDate}
                </span>
                <span className={styles.labelStarAppointment}>
                  *
                </span>
                <div className={styles.datePickerPage}>
                  <DatePicker
                    label={strings.endDate}
                    inputFormat={value => `${value.getMonth() + 1}/${value.getDate()}/${value.getFullYear()}`}
                    onChange={this.endDateAction}
                    value={this.state.endDate}
                    minDate={minDatetime}
                    sundayFirstDayOfWeek
                    theme={styles}
                  />
                </div>
              </div>
              <div className={styles.inputTextDiv} >
                <span className={styles.labelText}>
                  {strings.endTime}
                </span>
                <span className={styles.labelStarAppointment}>
                  *
                </span>
                <div className={styles.inputTextDiv} >
                  <div className={styles.pageDropDown}>
                    <span className={styles.labelSubText}>
                      {strings.hour}
                    </span>
                    <Dropdown
                      auto={false}
                      source={this.fetchHour()}
                      onChange={this.endHourAction}
                      value={this.state.endHour}
                      theme={styles}
                      className={styles.timeDropDown}
                    />
                  </div>
                  <div className={styles.pageDropDown}>
                    <span className={styles.labelSubText}>
                      {strings.minute}
                    </span>
                    <Dropdown
                      auto={false}
                      source={this.fetchMinutes()}
                      onChange={this.endMinuteAction}
                      value={this.state.endMinute}
                      theme={styles}
                      className={styles.timeDropDown}
                    />
                  </div>
                  <div className={styles.pageDropDown}>
                    <span className={styles.labelSubText}>
                      {strings.meridian}
                    </span>
                    <Dropdown
                      auto={false}
                      source={this.fetchMeridiemType()}
                      onChange={this.endMerdianMerdianAction}
                      value={this.state.endMerdian}
                      theme={styles}
                      className={styles.timeDropDownMeridian}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.fieldContainers}>
            <div className={styles.inputTextDivBig} >
              <span className={styles.labelText}>
                {strings.reminderXminutesbefore}
              </span>
              <span className={styles.labelStarAppointment}>
                *
              </span>
              <div className={styles.reminderPickerPage}>
                <Dropdown
                  auto={false}
                  label={this.state.reminder ? '' : strings.reminderXminutesbefore}
                  source={this.props.currentLanguage === 'es' ? this.remainderOptionsEs : this.remainderOptions}
                  onChange={this.reminderAction}
                  value={this.state.reminder}
                  theme={styles}
                  className={styles.remainderDropDown}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.saveDiv}>
          <div className={styles.buttonHolder}>
            <button
              className={styles.saveSpan}
              onClick={() => this.saveEventData()}
            >
              {strings.save}
            </button>
            <button
              className={styles.cancelSpan}
              onClick={() => this.props.closeAction()}
            >
              {strings.cancel}
            </button>
          </div>
        </div>
        <Dialog
          actions={this.action}
          active={this.state.active}
          onEscKeyDown={this.handleToggle}
          onOverlayClick={this.handleToggle}
          className={styles.alertDialog}
          theme={styles}
        >
          <p>{this.state.errorMessage}</p>
        </Dialog>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  fetchContactData: state.popup.fetchContactData,
});

export default connect(mapStateToProps, actions)(PopupAppointment);




// WEBPACK FOOTER //
// ./src/containers/PopupAppointment/PopupAppointment.js